import { EventEmitter } from "@shop/frontend/web/js/components/EventEmitter";
import api from "@shop/frontend/web/js/api";
import { translator } from "@shop/frontend/web/js/services/TranslatorService";
import { CartModel } from "@shop/frontend/web/js/models/CartModel";
import { Modal } from "@shop/frontend/web/js/components/Modal";

import { CartView } from "../views/CartView";

class CartController {
  constructor() {
    this.emitter = new EventEmitter();

    this.model = new CartModel();
    this.view = new CartView();
  }

  init() {
    this.setUpSubscribers();
    this.setUpListeners();

    translator.getLanguages().then(() => {
      this.initPromoCode();
    });

    if ($(".price-category-select").length > 0) this.initPriceLoyaltyCategories();
    if ($(".js-ticket-required-param-btn").length > 0) this.initTicketRequiredParam();
    if ($("[data-acquiring-id]").length > 0) this.initAcquirings();
    this.modal = new Modal();
    if ($("#fastRegisterModal").length)
      this.fastRegisterModal = new Modal().use("fastRegisterModal");
    if ($('.js-order-timer').length) {
      this.initTimer();
    };
  }

  setUpSubscribers() {
    /** @event CartController#event:remove-ticket */
    this.emitter.subscribe("event:remove-ticket", ({ sid, eventId, uid }) => {
      api.eventCart
        .removeFromCart({ eventId, sid, uid })
        .then((res) => {
          if (res.error) throw new Error(res.msg);
          if (!res.carts) return false;

          const orderData = this.model.validateOrder(res);

          window.CartService.count = window.CartService.count - 1;
          window.CartService.updateCount();

          this.view.removeOrderTickets(res.order_id, res.carts);
          this.view.renderOrder(orderData);

          this.emitter.emit("event:update-acquirings", { orderId: orderData.id });
        })
        .catch((err) => {
          this.modal.show(
            `
						${translator.t("main", "An error occurred when deleting from the basket!")}
						<p>${err.message}</p>
						`
          );

          this.modal.on("hide", () => window.location.reload());
        });
    });

    /** @event CartController#event:remove-event */
    this.emitter.subscribe("event:remove-event", ({ eventId, orderId }) => {
      api.eventCart
        .removeEventFromOrder({ eventId, orderId })
        .then((res) => {
          if (res.error) throw new Error(res.msg);
          if (res.refresh) return window.location.reload();
          if (!res.success) throw new Error("unknown");

          //TODO: пока так т.к. не получаем полный заказ как при удалении билета (или придумать что то)
          return window.location.reload();
        })
        .catch((err) => {
          console.log(err);
          this.modal.show(
            `
						${translator.t("main", "An error occurred when deleting from the basket!")}
						<p>${err.message}</p>
						`
          );

          this.modal.on("hide", () => window.location.reload());
        });
    });

    /** @event CartController#event:cancel-order */
    this.emitter.subscribe("event:cancel-order", (orderId) => {
      api.order
        .cancel({ orderId })
        .then((res) => {
          if (res.error) throw new Error(res.msg);

          //TODO: пока так т.к. не получаем полный заказ как при удалении билета (или придумать что то)
          return window.location.reload();
        })
        .catch((err) => {
          console.log(err);
          this.modal.show(
            `
						${translator.t("main", "An error occurred when deleting from the basket!")}
						<p>${err.message}</p>
						`
          );

          this.modal.on("hide", () => window.location.reload());
        });
    });

    this.emitter.subscribe("event:remove-sub-event", ({ eventId, subEventId }) => {
      api.subscription
        .removeEventSids({ eventId, subEventId })
        .then((res) => {
          if (!res.result) throw new Error(result.msg);

          const orderId = this.view.getOrderIdBySubEventId(subEventId);

          this.view.removeSubEvent(subEventId);

          const count = this.view.updateSubscriptionCount(orderId);
          if (!count > 0) return window.location.reload();

          this.view.renderOrderDiscount(orderId, 0);
          this.view.showSumLoader(orderId);

          api.eventCart.getCart({ eventId }).then((res) => {
            const orderSum = {};
            $.each(res, (i, order) => {
              if (order.id === orderId) {
                orderSum.sum = order.amount;
                orderSum.defaultSum = order.default_amount;
              }
            });

            this.view.renderOrderDiscount(orderId, orderSum.defaultSum - orderSum.sum);
            this.view.updateOrderSum(orderId, orderSum.sum);
          });
        })
        .catch((err) => {
          this.modal.show(
            `
						${translator.t("main", "An error occurred when deleting from the basket!")}
						<p>${err.message}</p>
						`
          );

          this.modal.on("hide", () => window.location.reload());
        });
    });

    /** @event CartController#event:clear-cart */
    this.emitter.subscribe("event:clear-cart", () => {
      api.order
        .cancelAll()
        .then((res) => {
          if (!res.result) throw new Error(res.message);

          //TODO: можно просто показать что корзина пуста
          return window.location.reload();
        })
        .catch((err) => {
          console.log(err);
          this.modal.show(
            `
						${translator.t("main", "An error occurred when deleting from the basket!")}
					<p>${err.message}</p>
						`
          );

          this.modal.on("hide", () => window.location.reload());
        });
    });
  }

  setUpListeners() {
    $(document).on("click", ".js-tickets-remove", (e) => {
      const sid = $(e.currentTarget).parents(".ticket-item").attr("data-place");
      const eventId = $(e.currentTarget).parents(".ticket-item").attr("data-event");
      const uid = $(e.currentTarget).parents(".ticket-item").attr("data-uid");

      this.emitter.emit("event:remove-ticket", { sid, eventId, uid });
    });

    $(document).on("click", ".js-order-revert", (e) => {
      const eventId = $(e.currentTarget).attr("data-event");
      const orderId = $(e.currentTarget).attr("data-order");

      this.emitter.emit("event:remove-event", { eventId, orderId });
    });

    $(document).on("click", ".js-buy-button", (e) => {
      const siteOrigin = window.location.origin;

      window.history.replaceState(siteOrigin, "", "/orders");
    });

    $(document).on("click", ".js-order-cancel", (e) =>
      this.emitter.emit("event:cancel-order", $(e.currentTarget).attr("data-order"))
    );

    $(document).on("click", "#js-order-clear", (e) => this.emitter.emit("event:clear-cart"));

    $(document).on("click", ".js-booking-delete", (e) => {
      const eventId = $(e.currentTarget).parents(".js-booking").data("event-id");
      const subEventId = $(e.currentTarget).parents(".js-booking").data("sub-event-id");

      return this.emitter.emit("event:remove-sub-event", { eventId, subEventId });
    });

    $(".js-bookings-open").on("click", (e) => {
      const element = $(e.currentTarget);

      element.toggleClass("active");
      return element.parents(".bookings").find(".js-bookings-wrapper").slideToggle();
    });

    $(".js-tickets-service-remove").on("click", (e) => {
      const uid = $(e.currentTarget).data("uid");
      const service_id = $(e.currentTarget).data("service");

      //todo: переделать без обновления страницы
      api.service.removeTicket({ service_id, uid }).then((res) => window.location.reload());
    });

    $(".js-order-service-delete").on("click", (e) => {
      const $tickets = $(e.currentTarget).parents(".js-order").find(".tickets");

      $.each($tickets, (index, elem) => {
        const count = $(elem).data("count");
        const serviceId = $(elem).data("service");
        api.service.removeService({ serviceId, count }).then((res) => {
          if (!res.carts.length) {
            //todo: переделать без обновления страницы
            window.location.reload();
          }
        });
      });
    });

    if ($("#skates-checkbox").length) {
      $(".order__button")[0].classList.add("order__button_disabled");
    }

    $("#skates-checkbox").on("click", () => {
      if ($("#skates-checkbox")[0].checked) {
        $(".order__button")[0].classList.remove("order__button_disabled");
      } else {
        $(".order__button")[0].classList.add("order__button_disabled");
      }
    });

    $(".js-refund-show").each((i,refund) => {
      $(refund).click((e) => {
        const eventId = $(e.target)
          .parents(".history__item")
          .find(".js-order-event")
          .data("eventId");
        const orderId = $(e.target)
          .parents(".history__header")
          .find(".history__order-number")
          .data("order");
        let fragment;
        api.refund
          .refund({ orderId, eventId, agree_refund: false })
          .then((res) => {
            if (res.canRefund) {
              fragment = document.importNode($("#js-template-refund")[0].content, true);
              const popup = new Modal();
              popup.show(fragment);
              $("#refund-amount").text(res.message);
              $("#js-close-modal").click(() => {
                popup.hide();
              });
              $("#js-return-confirm").click(() => {
                popup.hide();
                api.refund
                  .refund({ orderId, eventId, agree_refund: true })
                  .then(() => {
                    fragment = document.importNode(
                      $("#js-template-refund-success")[0].content,
                      true
                    );
                    popup.show(fragment);
                  })
                  .catch((err) => {
                    this.modal.show(
                      `
                      ${translator.t("main", "An error occurred!")}
                      <p>${err.message || "Неизвестная ошибка с сервера!"}</p>
                      `
                    );
                  });
              });
            } else {
              const tooltip = $(e.target).siblings("#js-tooltip-info");
              tooltip.show();
              tooltip.children(".tooltip-info__name").text(res.message);
              tooltip.children("#js-close-tooltip").click(() => tooltip.hide());
            }
          })
          .catch((err) => {
            this.modal.show(
              `
              ${translator.t("main", "An error occurred!")}
              <p>${err.message || "Неизвестная ошибка с сервера!"}</p>
              `
            );
          });
      });
    });
  }

  initPromoCode() {
    this.emitter.subscribe("event:apply-promo", ({ code, orderId }) => {
      if (!code.trim()) return false;
      api.promo
        .apply({ orderId, code: code.trim() })
        .then((res) => {
          if (!res.status) throw new Error(res.msg);

          const $promo = $(`.js-promo[data-order=${orderId}]`);

          $promo.find(".promo__button").addClass("active").text(translator.t("main", "Applied"));
          $promo.find(".promo__message").text("");
          $promo.find(".promo__input").val(code).attr("disabled", true);
          $promo.removeClass("active");

          const orderData = this.model.validateOrder({
            ...res,
            order_id: res.order_id ? res.order_id : orderId,
          });

          this.view.renderOrder(orderData);
        })
        .catch((err) => {
          console.log(err);
          $(`.js-promo[data-order=${orderId}]`)
            .find(".promo__message")
            .addClass("error")
            .text(err.message || translator.t("main", "An error occurred!"));
        });
    });

    $.each($(".js-promo"), (i, element) => {
      const promoInput = $(element).find(".promo__input");
      const promoMessage = $(element).find(".promo__message");
      promoInput.on("keypress", () => {
        promoMessage.text("");
        if (promoInput.val().trim()) $(element).addClass("active");
      });

      promoInput.on("input", () => {
        promoMessage.text("");
        if (promoInput.val().trim()) $(element).addClass("active");
      });

      promoInput.on("focus", () => {
        $(element).addClass("focus");
      });

      promoInput.on("blur", () => {
        $(element).removeClass("active").removeClass("focus");

        if (promoInput.val().trim()) {
          $(element).addClass("active").removeClass("focus");
        }
      });
    });

    $(document).on("keydown", ".js-promo .promo__input", (e) => {
      const orderId = $(e.target).parents(".js-promo").data("order");
      const code = $(e.target).val();

      if (e.which === 13 || e.keyCode === 13 || e.key === "Enter")
        return this.emitter.emit("event:apply-promo", { code, orderId });
    });

    $(document).on("click", ".js-promo .promo__button", (e) => {
      const orderId = $(e.target).parents(".js-promo").data("order");
      const code = $(e.target).parents(".js-promo").find(".promo__input").val();

      return this.emitter.emit("event:apply-promo", { code, orderId });
    });
  }

  initAcquirings() {
    $.each($("[data-acquiring-id]"), (i, $acquiring) => {
      if (!$($acquiring).attr("href")) return;

      $($acquiring).on("click", (e) => {
        e.preventDefault();
        const acquiringId = $($acquiring).attr("data-acquiring-id");
        const orderId = $($acquiring).parents(".order__item-wrap ").find(".js-order").data("id");
        api.pay
          .changePayAcquiring({ orderId, acquiringId })
          .then((res) => {
            if (!res.result) throw new Error(res.message || "");
            if ($($acquiring).hasClass("js-get-fast-registration")) return;

            return (window.location.href = $($acquiring).attr("href"));
          })
          .catch((err) => {
            if ($($acquiring).hasClass("js-get-fast-registration")) this.fastRegisterModal.hide();

            this.modal.show(
              `
									${translator.t("main", "An error occurred when deleting from the basket!")}
									<p>${err.message}</p>
								`
            );

            this.modal.on("hide", () => window.location.reload());
            console.log(err);
          });
      });
    });

    this.emitter.subscribe("event:update-acquirings", ({ orderId }) => {
      api.order.getAcquirings({ orderId }).then((res) => {
        $.each(res, (i, acquiringData) => {
          const isDisabled = acquiringData.disabled;
          const acquiring = acquiringData.acquiring;
          const $acquiring = $(`.js-order[data-id=${orderId}]`).find(
            `[data-acquiring-id=${acquiring.id}]`
          );

          if (isDisabled) {
            if (!$acquiring.hasClass("inactive")) $acquiring.addClass("inactive");
          } else {
            if ($acquiring.hasClass("inactive")) $acquiring.removeClass("inactive");
          }
        });
      });
    });
  }

  initTicketRequiredParam() {
    $(document).on("click", ".js-ticket-required-param-btn", (e) => {
      const $btn = $(e.currentTarget);
      this.modal.show(
        `
					<p>${$($btn).attr("data-extra-info-question")}</p>
					<div class="form-group">
						<input type="text" class="enter__input mb-0" value="${$($btn).attr(
              "data-extra-info"
            )}" placeholder="Введите ваши данные">
					</div>
          <button class="btn btn_wide" id="js-ticket-required-param" data-uid="${$($btn).attr(
            "data-uid"
          )}" data-dismiss="modal">Далее</button>
				`,
        { className: "i-modal_alert" }
      );

      //дизейблить кнопку если нет данных в инпуте
      const $input = $("#js-ticket-required-param").parent().find("input[type=text]");
      if (!$($input).val()) $("#js-ticket-required-param").addClass("inactive");

      $($input).on("keyup change", () => {
        if ($($input).val()) return $("#js-ticket-required-param").removeClass("inactive");
        return $("#js-ticket-required-param").addClass("inactive");
      });
    });

    $(document).on("click", "#js-ticket-required-param", (e) => {
      const uid = $(e.currentTarget).attr("data-uid");
      const text = $(e.currentTarget).parent().find("input[type=text]").val();
      api.eventCart
        .saveExtraInfo({ uid, text })
        .then((res) => {
          if (res.error) throw new Error(res.msg);

          if (res.success) {
            updateRequiredParamBtn(uid, text);
          }
        })
        .catch((err) => {
          this.modal.show(
            `
						${translator.t("main", "An error occurred!")}
						<p>${err.message}</p>
						`
          );
        });
    });

    $(".order__button").on("click", (e) => {
      if (!checkIsRequiredParamsValid()) {
        e.preventDefault();
        this.modal.show(
          `
					<p>Заполните обязательные поля под каждым билетом</p>
         			 <button class="btn btn_wide" data-dismiss="modal">Закрыть</button>
				`,
          { className: "i-modal_alert" }
        );
        return false;
      }
    });

    function updateRequiredParamBtn(uid, text) {
      const $oldBtn = $(`.js-ticket-required-param-btn[data-uid=${uid}]`);
      const template = `
				<div class="d-inline-flex align-self-start mt-2">
			    <strong class="text-uppercase mr-2">${text}</strong>
			    <button class="reset-btn text-success js-ticket-required-param-btn"
			            data-extra-info="${text}"
			            data-extra-info-question="${$oldBtn.attr("data-extra-info-question")}"
			            data-uid="${uid}"
			    >
			      Изменить
			    </button>
			  </div>
			`;

      if ($oldBtn.hasClass("text-success")) {
        $oldBtn.parent().after(template);
        $oldBtn.parent().remove();
      } else {
        $oldBtn.after(template);
        $oldBtn.remove();
      }
    }

    function checkIsRequiredParamsValid() {
      let isValid = true;
      $.each($(".js-ticket-required-param-btn"), (i, $btn) => {
        if (!$($btn).attr("data-extra-info")) {
          isValid = false;
          return false;
        }
      });
      return isValid;
    }
  }

  initPriceLoyaltyCategories() {
    $(".price-category-select input").on("change", (e) => {
      const $input = $(e.currentTarget);
      const orderId = $input.parents(".js-order").attr("data-id");
      const eventId = $input.parents(".js-order-event").attr("data-event-id");
      const uid = $input.parents(".ticket-item").attr("data-uid");
      const priceId = $input.val();
      const categoryId = $input.attr("data-category-id");

      function setActiveItem(id, name) {
        $input.parents(".price-category-select").attr("data-item-id", id);
      }

      function cancelSelect() {
        $.each($(".price-category-select input"), (i, elem) => {
          const currentId = $(elem).parents(".price-category-select").attr("data-item-id");
          if ($(elem).attr("data-category-id") === currentId) {
            $(elem).prop("checked", true);
          }
        });
      }

      api.eventCart
        .changePriceId({ eventId, orderId, uid, priceId, categoryId })
        .then((res) => {
          if (res.error) throw new Error(res.msg || "");

          setActiveItem(categoryId, $input.attr("data-name"));
          const orderData = this.model.validateOrder(res);
          this.view.renderOrder(orderData, true);
        })
        .catch((err) => {
          console.log(err);
          if (err.message && err.message === "Требуется хотя бы один взрослый билет!") {
            this.modal.show(`${err.message}`);
            cancelSelect();
            return false;
          }
          this.modal.show(
            `
						${translator.t("main", "An error occurred!")}
						<p>${err.message}</p>
						`
          );

          this.modal.on("hide", () => window.location.reload());
        });
    });
  }

  initTimer() {
		$(".js-order-timer").each(function () {
			const intervalId = setInterval(() => {
				const curTimer = this.textContent;
				const arrCurTimer = curTimer.split(":");
				let minutes = Number(arrCurTimer[0]);
				let seconds = Number(arrCurTimer[1]);

				seconds--;

				if (minutes <= 0 && seconds === 0) {
					clearInterval(intervalId);
					window.location.reload();
				}

				if (seconds < 0) {
					minutes--;
					seconds = 59;
				}

				if (seconds >= 0 && seconds < 10) {
					seconds = `0${seconds}`;
				}

				if (minutes >= 0 && minutes < 10) {
					minutes = `0${minutes}`;
				}

				this.textContent = `${minutes}:${seconds}`;
			}, 1000);
		});
	}
}

const cartController = new CartController();
cartController.init();
